import React from 'react';
import { useTheme } from '../../ThemeContext';
import { ModalShell, Button } from '../ui';


export default function EditProfileModal({ 
  show, 
  onClose,
  editDisplayName,
  setEditDisplayName,
  onUpdateDisplayName,
  authorName
}) {
  const { t, isDark } = useTheme();
  if (!show) return null;

  const handleClose = () => {
    setEditDisplayName(authorName);
    onClose();
  };

  return (
    <ModalShell onClose={handleClose} maxWidth="400px" panelStyle={{ backgroundColor: t.modalBg, borderRadius: '16px' }}>
        <h2 style={{ 
          fontFamily: 'Crimson Pro, serif', 
          fontSize: '28px', 
          marginBottom: '8px',
          color: t.text
        }}>
          Edit Display Name
        </h2>
        <p style={{ 
          color: t.textSecondary, 
          marginBottom: '24px',
          fontSize: '14px',
          fontFamily: 'Poppins, sans-serif'
        }}>
          Change how your name appears on your profile
        </p>

        <div style={{ marginBottom: '24px' }}>
          <input
            type="text"
            value={editDisplayName}
            onChange={(e) => setEditDisplayName(e.target.value)}
            placeholder="Display name"
            style={{
              width: '100%',
              padding: '12px',
              border: `1px solid ${t.borderStrong}`,
              borderRadius: '8px',
              fontSize: '14px',
              fontFamily: 'Poppins, sans-serif',
              outline: 'none'
            }}
            onFocus={(e) => e.target.style.borderColor = t.accent}
            onBlur={(e) => e.target.style.borderColor = t.borderStrong}
          />
        </div>

        <div style={{ display: 'flex', gap: '12px' }}>
          <Button onClick={onUpdateDisplayName} disabled={!editDisplayName.trim()} style={{ flex: 1 }}>
            Save
          </Button>
          <Button variant="secondary" onClick={handleClose} style={{ flex: 1 }}>
            Cancel
          </Button>
        </div>
    </ModalShell>
  );
}
